// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerBlock":"Footer_footerBlock__6tW5Y","footerBlockColumn":"Footer_footerBlockColumn__2T+W+","text":"Footer_text__LFzxy"};